import { sharingCopyFor } from './sharing-copy.ts';

// One home for the human-readable connection states shown by the workspace
// Connections page.
export const connectionStatusLabel = (status: string, locale?: string) => {
  const copy = sharingCopyFor(locale);
  const labels: Record<string, string> = {
    connected: copy.statusConnected,
    not_connected: copy.statusNotConnected,
    not_configured: copy.statusNotConfigured,
    needs_reauthorization: copy.statusNeedsReauthorization,
    unavailable: copy.statusUnavailable,
    disabled: copy.statusDisabled,
  };
  return labels[status] ?? status;
};
